import { render, staticRenderFns } from "./ContestationDetail.vue?vue&type=template&id=2fd79dbb"
import script from "./ContestationDetail.vue?vue&type=script&lang=js"
export * from "./ContestationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd79dbb')) {
      api.createRecord('2fd79dbb', component.options)
    } else {
      api.reload('2fd79dbb', component.options)
    }
    module.hot.accept("./ContestationDetail.vue?vue&type=template&id=2fd79dbb", function () {
      api.rerender('2fd79dbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/cancellation/ContestationDetail.vue"
export default component.exports